import { AlertTriangle, AlertCircle } from 'lucide-react';

/**
 * Upozornění na nekompletní data přímo v hlavičce položky.
 *
 * Dřív to viselo v neonové kartě „Kontrola & tipy" v pravém sloupci spolu
 * s tipy od Lami. Tipy skončily, ale kontrola je to podstatné — patří tam,
 * kde je člověk uvidí bez hledání.
 *
 * Když je vše v pořádku, nevykresluje nic: hlavička je hustá a „nic tu není"
 * je u upozornění srozumitelná zpráva. Stav v pořádku hlásí zelený semafor
 * v seznamu.
 */
export default function RecipeValidaceUpozorneni({ validace, mutedColor }) {
    const chyby = validace?.chyby || [];
    const varovani = validace?.varovani || [];
    if (!chyby.length && !varovani.length) return null;

    const jeChyba = chyby.length > 0;
    const barva = jeChyba ? '#EF4444' : '#F59E0B';
    const Icon = jeChyba ? AlertTriangle : AlertCircle;
    const texty = jeChyba ? chyby : varovani;

    return (
        <div className="inline-flex items-start gap-1.5 rounded-lg px-2 py-1"
            style={{ background: `${barva}14`, border: `1px solid ${barva}3D`, maxWidth: '100%' }}>
            <Icon size={12} style={{ color: barva, flexShrink: 0, marginTop: 2 }} />
            <span className="text-[11px] leading-snug" style={{ color: barva }}>
                {texty.join(' · ')}
                {jeChyba && varovani.length > 0 && (
                    <span style={{ color: mutedColor }}> · {varovani.join(' · ')}</span>
                )}
            </span>
        </div>
    );
}
